import { render, staticRenderFns } from "./VerifyRegistration.vue?vue&type=template&id=a5a24d98&scoped=true&"
import script from "./VerifyRegistration.vue?vue&type=script&lang=js&"
export * from "./VerifyRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a24d98",
  null
  
)

export default component.exports